export default "__VITE_ASSET__Buh0TNu6__"